(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('AgreementValuationSearch', AgreementValuationSearch);

    AgreementValuationSearch.$inject = ['$resource'];

    function AgreementValuationSearch($resource) {
        var resourceUrl =  'api/_search/agreement-valuations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
